module.exports = __webpack_public_path__ + "img/berget-logo-26-2.794bfc37.png";